/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Step_Hours_TitleInputs */

const en_platform_step_hours_title = /** @type {(inputs: Platform_Step_Hours_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your hours`)
};

const pl_platform_step_hours_title = /** @type {(inputs: Platform_Step_Hours_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustaw godziny`)
};

/**
* | output |
* | --- |
* | "Set your hours" |
*
* @param {Platform_Step_Hours_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_step_hours_title = /** @type {((inputs?: Platform_Step_Hours_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Step_Hours_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_step_hours_title(inputs)
	return en_platform_step_hours_title(inputs)
});